import { api } from "@/lib/api";

export const saveResponse = (res, fallback) => {
  const name = (res.headers["content-disposition"] || "").match(/filename="([^"]+)"/)?.[1] || fallback;
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a"); a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
};

export const downloadPersonalizedAttachment = async (assetId, me, myName = "") => {
  const form = { ...me, contact_name: myName.trim() || me.contact_name || "", include_logo: !!me.has_logo && me.include_logo !== false, shop_name: me.shop_name || "Velopaths Partner" };
  const res = await api.post(`/marketing/assets/${assetId}/personalized`, form, { responseType: "blob" });
  saveResponse(res, "Velopaths_Flyer.pdf");
};

// PNG version of a postcard PDF (one PNG, or a ZIP with Front/Back).
export const downloadPostcardPng = async (assetId) => {
  const res = await api.get(`/marketing/assets/${assetId}/png`, { responseType: "blob" });
  saveResponse(res, "Velopaths_Postcard.png");
};
